var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('omint-page',[_c('Header',{attrs:{"name":"Gestão de acessos","titleLabel":"Minhas Informações","backRoute":"/"}}),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }